module.exports = __webpack_public_path__ + "img/story6.8c90f349.jpeg";